

















import { round } from 'lodash';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

import { CUSTOMER_FEEDBACK } from './constants';
import { store } from '../../store/edit';
import { apiProvider } from './api';

export default EditStoreMixin.extend({
	name: 'CustomerFeedback',
	data() {
		return {
			CUSTOMER_FEEDBACK,
			AvarageRating: 0 as number,
			AverageDecimal: 0 as number,
		};
	},
	computed: {
		...genVuexComputeds(store),
	},
	async mounted() {
		this.AvarageRating = await this.updatedStar();
	},
	methods: {
		async updatedStar() {
			if (this.$route.params.id === null || this.$route.params.id === undefined) return 0;

			await apiProvider.getCustomerFeedbackAverage(this.$route.params.id).then((data) => {
				this.AvarageRating = round(data.data, 2);
				this.AverageDecimal = round(this.AvarageRating % 1, 1) * 10;
			});
			return this.AvarageRating;
		},
	},
});
